import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "error"]

  connect() {
    this.validate()
  }

  validate() {
    const fileInput = this.inputTarget
    if (!fileInput) return

    fileInput.addEventListener('change', (event) => {
      this.validateFile(event.target.files[0])
    })
  }

  validateFile(file) {
    const errorTarget = this.errorTarget
    
    if (!file) {
      this.hideError()
      return true
    }

    // Prüfe Dateityp
    if (!file.name.toLowerCase().endsWith('.json')) {
      this.showError('Bitte wählen Sie eine JSON-Datei aus.')
      return false
    }

    // Prüfe Dateigröße (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      this.showError('Die Datei ist zu groß. Maximale Größe: 5MB')
      return false
    }

    // Prüfe JSON-Inhalt
    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        JSON.parse(e.target.result)
        this.hideError()
      } catch (e) {
        this.showError(`Ungültige JSON-Datei: ${e.message}`)
      }
    }
    reader.readAsText(file)

    return true
  }

  showError(message) {
    const errorTarget = this.errorTarget
    errorTarget.textContent = message
    errorTarget.classList.remove('hidden')
  }

  hideError() {
    const errorTarget = this.errorTarget
    errorTarget.classList.add('hidden')
  }
}
